import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import SignIn from '../screens/SignIn';
import AppSwitcher from '../screens/AppSwitcher/AppSwitcher';
import TroubleLoggingIn from '../screens/TroubleLoggingIn/trouble-logging-in';
import CreateAccount from '../screens/CreateAccount/create-account';
import ResetPasswordOrActivateAccount from '../screens/ResetPassword';
import AuthenticatedRouteWrapper from './authenticated-route';
import { oktaAuthJSClient, getOauthBrowsingContextOrigin } from '../okta';
import { Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { createBrowserHistory } from 'history';
import EhrLaunch from '../screens/EhrLaunch';
import EhrCallback from '../screens/EhrCallback';
import Subscriptions from '../screens/Subscriptions';
import createNotetakerAccount from '../screens/CreateNotetakerAccount/create-notetaker-account';
import { ROUTES } from './routes';

export { ROUTES };

const history = createBrowserHistory();

function AppRouter() {
  function authHandler() {
    history.push(ROUTES.ROOT);
  }

  async function restoreOriginalUri(_oktaAuth, originalUri) {
    history.push(
      toRelativeUrl(originalUri || '/', getOauthBrowsingContextOrigin(), {
        replace: true,
      }),
    );
  }

  return (
    <Router history={history}>
      <Security oktaAuth={oktaAuthJSClient} onAuthRequired={authHandler} restoreOriginalUri={restoreOriginalUri}>
        <Switch>
          <Route path={ROUTES.ROOT} exact component={SignIn} />
          <Route path={ROUTES.CREATE_ACCOUNT} exact component={CreateAccount} />
          <Route path={ROUTES.CREATE_NOTETAKER_ACCOUNT} exact component={createNotetakerAccount} />
          <Route path={ROUTES.SUBSCRIPTIONS} exact component={Subscriptions} />
          <Route path={ROUTES.TROUBLE_LOGGING_IN} exact component={TroubleLoggingIn} />
          <Route path={ROUTES.EHR_OKTA_CALLBACK} component={LoginCallback} />
          <Route path={ROUTES.IMPLICIT_CALLBACK} component={LoginCallback} />
          <Route path={ROUTES.RESET_PASSWORD_OR_ACTIVATE_ACCOUNT} component={ResetPasswordOrActivateAccount} />
          <Route path={ROUTES.EHR_LAUNCH} component={EhrLaunch} />
          <Route path={ROUTES.EHR_CALLBACK} component={EhrCallback} />
          <AuthenticatedRouteWrapper path={ROUTES.APP_SWITCHER} component={AppSwitcher} />
          <Redirect path={ROUTES.SIGNIN} to={ROUTES.ROOT} />
        </Switch>
      </Security>
    </Router>
  );
}

export default AppRouter;
